<template>
  <div>
    <div class="row">
      <div class="col-md-12 mb-2">
        <form :action="$store.state.url + 'analytic_logs/'" id="export-analytic-logs" method="get">
          <div class="block text-right">
            <button class="btn btn-success white float-right" type="submit">
              Exportar analytics de telas <i class="fa fa-file-export"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <base-table
      :ref="table"
      :filters="filters"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :endPoint="endPoint"
      :enableAdd="false"
      :enableEdit="false"
      :enableDelete="false"
      :relationships="relationships"
      :extras="extras"
      :columns="columns"
      :enableExtract="false"
      :orders="orders"
    ></base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/Layouts/BaseTable.vue";

export default {
  data() {
    return {
      extras: [],
      crudName: "Analytics de Telas",
      filters: [
        {
          id: "user_name",
          name: "user_name",
          label: "Nome do Usuário",
          value: "",
          type: "text",
          class: "form-control",
          columnSize: "col-3",
        },
        {
          id: "customer_name",
          name: "customer_name",
          label: "Cliente",
          value: "",
          type: "text",
          class: "form-control",
          columnSize: "col-3",
        },
        {
          id: "type_name",
          name: "type_name",
          label: "Tipo",
          value: "",
          type: "select",
          class: "form-control",
          columnSize: "col-3",
          options: [
            { value: "", label: "Todos" },
            { value: "cliente", label: "Cliente" },
            { value: "interno", label: "Interno" },
          ],
        },
        {
          id: "screen",
          name: "screen",
          label: "Tela",
          value: "",
          type: "text",
          class: "form-control",
          columnSize: "col-3",
        },
      ],
      newText: "",
      table: "analytic_logs",
      endPoint: "analytic_logs/",
      relationships: [],
      orders: [],
      columns: [
        { label: "ID", field: "id" },
        { label: "Usuário", field: "user_name" },
        { label: "Cliente", field: "customer_name" },
        { label: "Tipo", field: "type_name" },
        { label: "Tela", field: "screen" },
        { label: "Data", field: "created_at_f" },
      ],
    };
  },
  components: {
    BaseTable,
  },
};
</script>
